module.exports = __webpack_public_path__ + "media/img/uploads/logo-nvesd-9fd60101405b935a0a2208755fb75b48.png";